module.exports = __webpack_public_path__ + "media/common/logo-imk-b37d8bdc.svg";